  document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.getElementById("blogSearch");
  const blogPosts = document.querySelectorAll(".items-2");
  const searchResultText = document.getElementById("search-result-text");
  const searchQuerySpan = document.getElementById("searchQuery");
  const searchCountSpan = document.getElementById("searchCount");
  const circleAdditional = document.getElementById("circleAdditional");
  
  const allCircleItems = Array.from(circleAdditional.querySelectorAll(".circle-items")).map(item => ({
    text: item.getAttribute("data-text") || '',
    imgSrc: item.getAttribute("data-img-src") || '',
    alt: item.getAttribute("data-alt") || '',
    href: item.getAttribute("href") || '#'
  }));
  
  
  function normalize(str) {
    return str.toLowerCase().trim();
  }
  
  function renderFilteredCircleItems(filteredItems) {
    circleAdditional.innerHTML = '';
    filteredItems.forEach(item => {
      const html = `
        <a href="${item.href}" class="circle-items items-2"
           data-text="${item.text}"
           data-img-src="${item.imgSrc}"
           data-alt="${item.alt}">
          ${item.imgSrc ? `<img src="${item.imgSrc}" alt="">` : ''}
          <p>${item.text}</p>
        </a>
      `;
      circleAdditional.insertAdjacentHTML("beforeend", html);
    });
  }
  
  function searchBlog() {
    const query = normalize(searchInput.value);
  
    let matchCount = 0;
    if(searchInput.value != ""){
      document.querySelector('.search-result').style.display = 'block';
      document.querySelector('.search-result').setAttribute('role', 'alert');
    } 
    blogPosts.forEach(post => {
      const title = post.getAttribute("data-title")?.toLowerCase() || "";
      const tags = post.getAttribute("data-tags")?.toLowerCase() || "";
      const matches = title.includes(query) || tags.includes(query);
  
      post.style.display = (!query || matches) ? "block" : "none";
      if (matches) matchCount++;
    });
  
    const filteredCircles = allCircleItems.filter(item =>
      item.text.toLowerCase().includes(query)
    );
    
    renderFilteredCircleItems(query ? filteredCircles : allCircleItems);
    
    if (query) {
      searchResultText.textContent = "Showing articles that mention";
      searchQuerySpan.textContent = `'${query}'`;
      searchCountSpan.textContent = `${matchCount} results`;
    } else {
      searchResultText.textContent = "";
      searchQuerySpan.textContent = "";
      searchCountSpan.textContent = "";
    }
  }
  
  searchInput.addEventListener("input", searchBlog);
        if($('[data-notes-slider] .circle-items').length > 5 && _theme.isLaptopAndUp){
          _theme.initSlickSlider($('[data-notes-slider]'),{
              infinite: false,
              arrows: true,
              dots: false,
              slidesToShow: 5,
              slidesToScroll: 5,
              responsive: [
          
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    arrows: true
          
                  }
                },
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    arrows: true
          
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 2,
                    arrows: true
          
                  }
                }
              ]
            })
        }           
  });
